import styled from 'styled-components';

const CardHeaderStyled = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: top;
  margin-bottom: 16px;

  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.gray950};

  ${({ css }) => css}
`;

const Title = styled.strong`
  font-size: 22px;
  line-height: 32px;
  font-weight: 500;
`;

const TooltipStyled = styled.div`
  display: flex;
  gap: 8px;
`;

const EditButton = styled.div`
  display: flex;
  cursor: pointer;

  ${({ $disabled }) =>
    $disabled &&
    `
    opacity: 0.5;
    cursor: not-allowed;
  `}
`;

export { CardHeaderStyled, Title, TooltipStyled, EditButton };
